import { EditBasketComponent } from './edit-basket/edit-basket.component';
import { AddBasketComponent } from './add-basket/add-basket.component';
import { Routes, RouterModule } from '@angular/router';
import { ModuleWithProviders } from '@angular/core';
import { ListBasketsComponent } from './list-baskets/list-baskets.component';

export const routesBasket: Routes = [
    { path: 'page-cfg-basket', component: ListBasketsComponent },
    { path: 'page-cfg-basket/add', component: AddBasketComponent },
    { path: 'page-cfg-basket/:id/edit', component: EditBasketComponent },
];

export const BasketRoutes: ModuleWithProviders = RouterModule.forChild(routesBasket);
